module.exports = __webpack_public_path__ + "img/Pascal-De-Munck-white-hires.cf0de338.png";